export const environment = {
  production: true,
  maintenanceMode: false, // Passer à true pour activer le mode maintenance
  cartesAstuceMaintenanceMode: false, // Passer à true pour activer le mode maintenance de l'e-boutique (Mes cartes Astuce)
  communicationsFormTransdev: true,
  baseWebSite: '',
  baseUrlMyAstuce: 'https://www-int.myastuce.fr',
  language: {
    localeKey: 'locale',
    default: 'fr',
  },
  timeoutWebServiceCMS: 7000,
  homePageNewsNumber: 8,
  paginationNewsNumber: 10,
  baseUrlApiMgt: 'https://api-int.myastuce.fr/content',
  cleApiName: 'Ocp-Apim-Subscription-Key',
  cleApi: '73511e26e64cbbc86f38c245784d22f2',
  buildNumber: '20260826.2',
  baseUrlCityway: 'https://preprod.staticwc.mrn.cityway.fr',
  versionWebComponentCityway: '3.1',
  formulaireContactMaaSCityway: 'https://ca.preprod.microtransit.cityway.fr/MRN/Claim',
  disruptionsCitywayUrl: 'https://preprod.api.mrn.cityway.fr/disrupt/api/v1/fr/disruptions', // API des infos trafic cityway
  searchCharacterMin: 100,
  searchCharacterMax: 100,
  name: 'int'
};

